<template>
  <div class="table">
    <div class="tableOperate" v-if="hasOperate">
      <slot name="tableOpeate"></slot>
    </div>
    <el-table
      ref="multipleTable"
      :header-row-class-name="customClass ? customClass : 'tableBody'"
      :data="tableData"
      height="100%"
      :border="border"
      :row-key="rowKey"
      @selection-change="handleSelectionChange"
      :tree-props="treeProps" :stripe="stripe" style="width: 100%"
      :load="load"
      :lazy="lazyLoad"
      >
      <el-table-column
        v-if="showSelect"
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.key"
        :label="item.name"
        :width="item.width">
        <template slot-scope="scope">
          <slot :name="item.key" :item="scope.row" v-if="item.type === 'custom'"></slot>
          <label v-else>{{scope.row[item.key]}}</label>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageFooter" v-if="!hiddenFooter">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="pageChange"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicTable",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    stripe: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    rowKey: {
      type: String,
      default: 'id',
    },
    hiddenFooter: {
      type: Boolean,
      default: false,
    },
    treeProps: {},
    showSelect: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    border: {
      type: Boolean,
      default: true,
    },
    hasPadding: {
      type: Boolean,
      default: true,
    },
    hasOperate: {
      type: Boolean,
      default: false,
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    node: {
      type: Array,
      default: () => [],
    }
  },
  watch:{
    newNode(val) {
      this.node = val
    }
  },
  methods: {
    pageChange(index) {
      this.$emit('pageChange', index);
    },
    clearSelected() {
      this.$refs.multipleTable.clearSelection();
    },
    handleSelectionChange(val) {
      this.$emit('selectChange', val);
    },
    async load(tree,treeNode,resolve) {
      await this.$parent.getNode(tree.id)
      resolve(this.$parent.node)
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  background: #fff;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
  & /deep/ .el-table {
    flex: 1;
  }
}
.pageFooter {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
  .tableBody {
    & > th {
      > .cell {
        font-weight: 600;
      }
    }
  }
  .table{
    border-collapse: collapse;
  }
  .table td,.table.th{
    border-bottom: 1px solid #ecf2f7;
    border-right: 0!important;
  }
  .table .el-table th,.table .el-table td{
    text-align: center;
  }
</style>